module.exports = __webpack_public_path__ + "media/hint.6fc96ff8.mp3";